export const BASE_URL = 'https://www.pre-onboarding-selection-task.shop';
export const ACCESS_TOKEN_KEY = 'access_token';
